import { ROUTES_NAMES } from '@/constants';
import { beforeEnterLoginFederatedRoute } from './loginFederatedNavigationGuards';
import { RouteRecordRaw } from 'vue-router';
import RegistrationPanel from '@/views/RegistrationPanel.vue';

const loginFederatedRoute: RouteRecordRaw = {
  path: '/login/federated',
  name: ROUTES_NAMES.federatedLogin,
  component: RegistrationPanel,
  beforeEnter: beforeEnterLoginFederatedRoute
};

export default loginFederatedRoute;
